import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_ROLE_DETAIL,
    getRoleDetailFail,
    getRoleDetailSuccess
} from '../action/getRoleDetailAction'

// api 
import getRoleDetailApi from '../api/getRoleDetailApi'

export function* getRoleDetailSaga(action) {
    try {
        const response = yield call(() => getRoleDetailApi(action.params))
        if (response.data.status === 1) {
            yield put(getRoleDetailSuccess(response, action))
        } else {
            yield put(getRoleDetailFail(response, action))
        }
    }
    catch (e) {
        yield put(getRoleDetailFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_ROLE_DETAIL, getRoleDetailSaga)
}